import { computed, ref, watch, onMounted, onBeforeUnmount, type Ref } from 'vue'
import useUserStore from '~/store/modules/user'
import { useSiteConfig } from '~/config/useSiteConfig'
import LegacyServer from '~/services/LegacyEnterpriseServer'
import type { LegacyWorkspaceSummary } from '~/services/LegacyEnterpriseServer/types'
import { getEnterpriseWorkspaceMode } from '~/utils/enterpriseManagement'
import { createLegacyWorkspaceLoader } from '~/utils/legacyEnterpriseWorkspace'

export function useLegacyEnterpriseWorkspace(enabled: Ref<boolean> = ref(true)) {
  const user = useUserStore()
  const { isVipSite } = useSiteConfig()
  const summary = ref<LegacyWorkspaceSummary | null>(null)
  const loading = ref(false)
  const authorized = computed(() => enabled.value && user.token && user.isUserInfoReady
    && user.userInfo?.bizTeamId === user.bizTeamInfo?.id
    && [1, 2].includes(Number(user.userInfo?.bizTeamMemberRole))
    && getEnterpriseWorkspaceMode(user.bizTeamInfo) === 'legacy-cross')
  const loader = createLegacyWorkspaceLoader(LegacyServer.workspaceSummary,
    value => { summary.value = value }, value => { loading.value = value })
  let stop: (() => void) | undefined
  onMounted(() => {
    stop = watch(() => authorized.value
      ? [user.token, user.userInfo.id, user.userInfo.bizTeamId, user.userInfo.bizTeamMemberRole,
        user.bizTeamInfo.legacyMigrationNo, user.bizTeamInfo.migrationServiceState, isVipSite.value].join(':') : '', identity => {
      loader.reset(identity, user.bizTeamInfo?.legacyMigrationNo || '', isVipSite.value ? 'VIP' : 'AI')
      void loader.refresh()
    }, { immediate: true, flush: 'sync' })
  })
  onBeforeUnmount(() => { stop?.(); loader.dispose() })
  return { summary, loading, authorized, refresh: () => loader.refresh() }
}
